import React, {useEffect, useState} from "react";
import {Route, Routes} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "quill/dist/quill.core.css";
import "./App.css";

import AuthService from "./services/auth.service";

import Login from "./components/auth/login.component";
import Register from "./components/auth/register.component";
import Home from "./components/home.component";
import Profile from "./components/profile/profile.component";
import BoardAdmin from "./components/board-admin.component";

import EventBus from "./common/EventBus";
import pfLogo from './img/logo-color2.png';
import VenuesList from "./components/venues/venuesList.component";
import ActsList from "./components/acts/actsList.component";

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import ActDetail from "./components/acts/actDetail.component";
import VenueDetail from "./components/venues/venueDetail.component";
import {NavDropdown, Toast} from "react-bootstrap";
import MyActsList from "./components/profile/myActsList.component";
import MyVenuesList from "./components/profile/myVenuesList.component";
import AuthVerify from "./common/auth-verify";
import About from "./components/about.component";
import ContactForm from "./components/contact/contactForm.component";
import ContactThankYou from "./components/contact/contactThankYou.component";
import CurrentPF from "./components/current_pf.component";
import FAQ from "./components/faq.component";
import ForgotPassword from "./components/auth/forgotPass.component";
import ResetPassword from "./components/auth/resetPass.component";
import {getActiveKey} from "./common/utils";
import VenueContact from "./components/venues/venueContact.component";
import ActContact from "./components/acts/actContact.component";
import Waivers from "./components/waivers.component";
import Schedule from "./components/schedule/schedule.component";
import AllSchedule from "./components/schedule/allSchedule.component";

const App = (props) => {
    const [currentUser, setCurrentUser] = useState();
    const [signedInAs, setSignedInAs] = useState("");
    const [showToast, setShowToast] = useState(false);

    let activeKey = getActiveKey();

    const toggleShowToast = () => {
        console.log("-- before: " + showToast)
        setShowToast(!showToast);
        console.log("-- after: " + showToast)
    }

    const logOut = () => {
        AuthService.logout();
        setCurrentUser(undefined);
    }

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (user) {
            setCurrentUser(user);
            setSignedInAs(user.name);
        }
        EventBus.on("logout", () => {
            logOut();
        });
    }, []);

    useEffect(() => {
        return () => {
            EventBus.remove("logout");
        }
    }, [currentUser]);

    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary" bg="dark" data-bs-theme="dark">
                <Container>
                    <Navbar.Brand href="/">
                        <img src={pfLogo} alt="Winchester Porchfest" title="Winchester Porchfest" height="40px"/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto" activeKey={activeKey}>
                            <Nav.Link href="/porchfest">Porchfest 2025</Nav.Link>
                            <Nav.Link href="/schedule">Schedule</Nav.Link>
                            <Nav.Link href="/acts">Acts</Nav.Link>
                            <Nav.Link href="/venues">Venues</Nav.Link>
                            <Nav.Link href="/contact">Contact</Nav.Link>
                            <Nav.Link href="/about">About</Nav.Link>
                            <Nav.Link href="/faq">FAQ</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                    <Navbar.Collapse className="justify-content-end">
                        <Nav activeKey={activeKey}>
                            {!currentUser &&
                                <Nav.Link href={"/login"}>Login / Register</Nav.Link>
                            }
                        </Nav>
                        <Nav activeKey={activeKey}>
                            {currentUser &&
                                <NavDropdown title={signedInAs} id="basic-nav-dropdown">
                                    <NavDropdown.Item href={"/profile"}>Profile</NavDropdown.Item>
                                    {currentUser.is_performer &&
                                        <NavDropdown.Item href={"/myacts"}>My Acts</NavDropdown.Item>
                                    }
                                    {currentUser.is_host &&
                                        <NavDropdown.Item href={"/myvenues"}>My Venues</NavDropdown.Item>
                                    }
                                    <NavDropdown.Divider/>
                                    <NavDropdown.Item href={"/"} onClick={logOut}>Logout</NavDropdown.Item>
                                </NavDropdown>
                            }
                        </Nav>

                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <Toast show={showToast} onClose={toggleShowToast}>
                <Toast.Header>
                    <strong className="me-auto">ERROR</strong>
                    <small>there was some error</small>
                </Toast.Header>
                <Toast.Body>Woohoo, you're reading this text in a Toast!</Toast.Body>
            </Toast>

            <div className="container mt-3">

                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/about" element={<About/>}/>
                    <Route path="/contact" element={<ContactForm/>}/>
                    <Route path="/contact-thankyou" element={<ContactThankYou/>}/>
                    <Route path="/porchfest" element={<CurrentPF/>}/>
                    <Route path="/faq" element={<FAQ/>}/>

                    <Route path="/venues" element={<VenuesList/>}/>
                    <Route exact path="/venues/new" element={<VenueDetail/>}/>
                    <Route exact path="/venues/:venueId" element={<VenueDetail/>}/>
                    <Route exact path="/venues/:venueId/edit" element={<VenueDetail/>}/>
                    <Route exact path="/venues/:venueId/slots/edit" element={<VenueDetail/>}/>
                    <Route exact path="/venues/:venueId/contact" element={<VenueContact/>}/>
                    <Route path="/myvenues" element={<MyVenuesList/>}/>

                    <Route path="/acts" element={<ActsList/>}/>
                    <Route exact path="/acts/new" element={<ActDetail/>}/>
                    <Route exact path="/acts/:actId" element={<ActDetail/>}/>
                    <Route exact path="/acts/:actId/edit" element={<ActDetail/>}/>
                    <Route exact path="/acts/:actId/contact" element={<ActContact/>}/>
                    <Route path="/myacts" element={<MyActsList/>}/>

                    <Route path="/login" element={<Login/>}/>
                    <Route path="/register" element={<Register/>}/>
                    <Route path="/forgotpass" element={<ForgotPassword/>}/>
                    <Route path="/resetpass" element={<ResetPassword/>}/>
                    <Route path="/profile" element={<Profile/>}/>
                    <Route path="/profile/:userEmail" element={<Profile/>}/>
                    {/*<Route path="/user" element={<BoardUser />} />*/}
                    {/*<Route path="/mod" element={<BoardModerator/>}/>*/}
                    <Route path="/admin" element={<BoardAdmin/>}/>
                    <Route path="/waivers" element={<Waivers/>}/>
                    <Route path="/schedule" element={<AllSchedule/>}/>
                    <Route path="/schedule-final" element={<Schedule/>}/>
                </Routes>
            </div>

            <AuthVerify logOut={logOut}/>

        </>
    )

};

export default App;
